import { render, staticRenderFns } from "./EventBanner.vue?vue&type=template&id=1b0ead0d&scoped=true"
import script from "./EventBanner.vue?vue&type=script&lang=js"
export * from "./EventBanner.vue?vue&type=script&lang=js"
import style0 from "./EventBanner.vue?vue&type=style&index=0&id=1b0ead0d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0ead0d",
  null
  
)

export default component.exports